module.exports = __webpack_public_path__ + "static/media/IconX.9a315f1b.svg";